import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	preventPushTitleNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.prevent-push-title-non-final',
		defaultMessage: 'Prevent push notifications from Opsgenie mobile app',
		description: 'Preventing push notifications task description',
	},
	deleteOgContactMethodsTitleNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.delete-og-contact-methods-title-non-final',
		defaultMessage: 'Delete your Opsgenie contact methods',
		description: 'Opsgenie contact methods task description',
	},
	contactMethodTitleNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.contact-method-title-non-final',
		defaultMessage: 'Keep your contact methods up to date',
		description: 'Keeping contact methods up to date task description',
	},
	usersAndRolesTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.users-and-roles-task-one-non-final',
		defaultMessage: 'How to manage users and roles',
		description: 'Users and roles step task one description',
	},
	usersAndRolesTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.users-and-roles-task-two-non-final',
		defaultMessage:
			"{count, plural, =0 {All Opsgenie admins now have the product admin role} one {{count} Opsgenie admin doesn't have the product admin role} other {{count} Opsgenie admins don't have the product admin role}}",
		description: 'Users and roles step task two description',
	},
	usersAndRolesTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.users-and-roles-task-three-non-final',
		defaultMessage:
			'{count, plural, =0 {All Opsgenie users now have a product role} one {{count} Opsgenie user no longer have custom roles} other {{count} Opsgenie users no longer have custom roles}}',
		description: 'Users and roles step task three description',
	},
	usersAndRolesTaskFourNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.users-and-roles-task-four-non-final',
		defaultMessage: 'Stakeholders are now in Jira Service Management',
		description:
			'Users and roles step task four description when optimal tooling and user is site admin',
	},
	alertsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.alerts-task-one-non-final',
		defaultMessage: 'Meet the redesigned alerts on Jira',
		description: 'Alerts step task one description',
	},
	alertsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.alerts-task-two-non-final',
		defaultMessage: 'Where to find your alerts',
		description: 'Alerts step task two description',
	},
	alertsTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.alerts-task-three-non-final',
		defaultMessage: 'What happens to Opsgenie alerts',
		description: 'Alerts step task three description',
	},
	alertsTaskFourNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.alerts-task-four-non-final',
		defaultMessage: 'How to check and manage your on-call schedules',
		description: 'Alerts step task four description',
	},
	notificationsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.notifications-task-one-non-final',
		defaultMessage: 'How to manage your alert notifications',
		description: 'Notifications step task one description',
	},
	notificationsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.notifications-task-two-non-final',
		defaultMessage: 'Add Jira Cloud mobile app as your notification method',
		description: 'Notifications step task two description',
	},
	notificationsTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.notifications-task-three-non-final',
		defaultMessage: 'Prevent duplicate notifications from Opsgenie mobile app',
		description: 'Notifications step task two description',
	},
	teamsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.teams-task-one-non-final',
		defaultMessage: 'Why launch operations for your team',
		description: 'Teams step task one description',
	},
	teamsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.teams-task-two-non-final',
		defaultMessage: 'Opsgenie teams are now in Jira Service Management',
		description: 'Teams step task two description',
	},
	chatToolsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.chat-tools-task-one-non-final',
		defaultMessage: 'How chat tools help with alerting',
		description: 'Chat tools step task one description',
	},
	chatToolsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.chat-tools-task-two-non-final',
		defaultMessage: 'Connect your chat tools with Jira Service Management',
		description: 'Chat tools step task two description',
	},
	chatToolsTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.chat-tools-task-three-non-final',
		defaultMessage: 'Copy your Opsgenie chat integrations to Jira Service Management',
		description: 'Chat tools step task three description',
	},
	chatToolsTaskFourNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.chat-tools-task-four-non-final',
		defaultMessage: 'Prevent duplicate notifications from Opsgenie chat integrations',
		description: 'Chat tools step task four description',
	},
	automateAlertsAndIncidentResponseTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.automate-alerts-and-incident-response-task-one-non-final',
		defaultMessage: 'Recreate Opsgenie alert actions and incident rules in Jira',
		description: 'Automate alerts and incident response step task one description',
	},
	automateAlertsAndIncidentResponseTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.automate-alerts-and-incident-response-task-two-non-final',
		defaultMessage: 'Delete your Opsgenie actions and incident rules',
		description: 'Automate alerts and incident response step task two description',
	},
	integrationsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.integrations-task-one-non-final',
		defaultMessage: 'Where to find your integrations',
		description: 'Integrations step task one description',
	},
	integrationsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.integrations-task-two-non-final',
		defaultMessage: 'Syncing your alerts with software and service projects',
		description: 'Integrations step task two description',
	},
	integrationsTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.integrations-task-three-non-final',
		defaultMessage: 'Integrations unavailable for addition in Jira Service Management',
		description: 'Integrations step task three description',
	},
	integrationsTaskFourNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.integrations-task-four-non-final',
		defaultMessage: 'Integrations left behind in Opsgenie',
		description: 'Integrations step task four description',
	},
	integrationsTaskFiveNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.integrations-task-five-non-final',
		defaultMessage: 'Incoming call routing',
		description: 'Integrations step task five description',
	},
	deprecatedOnesTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.deprecated-ones-task-one-non-final',
		defaultMessage:
			'{deprecatedFeaturesCount, plural, one {{deprecatedFeaturesCount} feature is} other {{deprecatedFeaturesCount} features are}} left behind in Opsgenie',
		description: 'Deprecated features step task one description',
	},
	heartbeatsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.heartbeats-task-one-non-final',
		defaultMessage: "Use the updated heartbeats' address in your systems",
		description: 'Heartbeats step task one description',
	},
	heartbeatsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.heartbeats-task-two-non-final',
		defaultMessage: 'Outdated heartbeats won’t sync to Jira Service Management',
		description: 'Heartbeats step task two description',
	},
	heartbeatsTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.heartbeats-task-three-non-final',
		defaultMessage: 'Remove excess heartbeats',
		description: 'Heartbeats step task three description',
	},
	incidentsTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.incidents-task-one-non-final',
		defaultMessage: 'Find your Opsgenie incidents in Jira Service Management',
		description: 'Incidents step task one description',
	},
	incidentsTaskTwoNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.incidents-task-two-non-final',
		defaultMessage: 'Incident status and priority in Jira Service Management',
		description: 'Incidents step task two description',
	},
	incidentsTaskThreeNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.incidents-task-three-non-final',
		defaultMessage: '4 incident features are left behind in Opsgenie',
		description: 'Incidents step task three description',
	},
	incidentsTaskFourNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.incidents-task-four-non-final',
		defaultMessage: 'Copy new Opsgenie incidents to Jira Service Management',
		description: 'Incidents step task four description',
	},
	incidentsTaskFourSuccessNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.incidents-task-four-success-non-final',
		defaultMessage: 'You’ve successfully copied your incidents to Jira',
		description: 'Incidents step task four description if copy operartion is successful',
	},
	findWhatYouAreLookingForTaskOneNonFinal: {
		id: 'eoc-changeboarding.common.utils.tasks.find-what-you-are-looking-for-task-one-non-final',
		defaultMessage: 'Navigate to your work quickly',
		description: 'Find what you are looking for step task one description',
	},
});
